import * as React from "react";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { IStackStyles, Stack, StackItem } from "@fluentui/react";

const loaderStackStyles: Partial<IStackStyles> = {
  root: { width: "100%", height: "100%", margin: 0, padding: 0, overflow: "auto" }
};

interface ILoaderProps {
  label?: string;
  hideLabel?: boolean;
  hide?: boolean;
}

export const Loader: React.FunctionComponent<ILoaderProps> = props => {
  const languageStrings = React.useContext(LanguageContext);

  return (
    !props.hide && <Stack verticalAlign="center" horizontalAlign="center" styles={loaderStackStyles}>
      <StackItem align="center">
        <Spinner
          label={!props.hideLabel && (!props.label ? languageStrings.RetrievingInfo : props.label)}
          ariaLive="assertive"
          labelPosition="bottom"
        />
      </StackItem>
    </Stack>
  );
};

export default Loader;
